import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { AfterViewInit, Component, computed, DestroyRef, ElementRef, inject, Renderer2, Signal, ViewChild } from '@angular/core';
import { APP_CONFIG } from '@configuration/configuration';
import { Configuration } from '@models/interfaces/configuration/index.interface';
import { DvmService } from '@services/dvm.service';
import anime from 'animejs';
import { skip } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-loader',
    imports: [],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.css'
})
export class LoaderComponent implements AfterViewInit {
  
  // VIEW CHILD
  @ViewChild('loaderContainer', { read: ElementRef })
  private  readonly loaderContainer!:  ElementRef<HTMLElement>;

  @ViewChild('loader', { read: ElementRef })
  private  readonly loader!:  ElementRef<HTMLElement>;

  // SERVICES
  private  readonly config:       Signal<Configuration> = inject(APP_CONFIG);
  private  readonly viewer:       MapViewerService      = inject(DvmService).viewer; 
  private  readonly destroyRef:   DestroyRef            = inject(DestroyRef);
  private  readonly renderer:     Renderer2             = inject(Renderer2);

  // COMPONENT STATE
  private            loaderVisible: boolean           = false;
  protected readonly logo:          Signal<string>    = computed((): string => this.config().General.client.logo);


  // LIFECYCLE HOOKS
  ngAfterViewInit(): void {
    this.initComponent();
  }

  // METHODS
  private toggleLoader(show: boolean): void {
    if(show === this.loaderVisible) return;

    const container: HTMLElement = this.loaderContainer.nativeElement,
          loader:    HTMLElement = this.loader.nativeElement;

    anime.remove(loader);
    this.loaderVisible = show;

    if(show) {
      this.renderer.removeClass(container, 'hidden');
      this.renderer.removeClass(container, 'pointer-events-auto');
      this.renderer.addClass(container, 'pointer-events-none');
    } else {
      this.renderer.removeClass(container, 'pointer-events-auto');
      this.renderer.addClass(container, 'pointer-events-none');
    }

    anime({
      complete: (): void => {
        if(show) {
          this.renderer.removeClass(container, 'pointer-events-none');
          this.renderer.addClass(container, 'pointer-events-auto');
        } else {
          this.renderer.addClass(container, 'hidden');
        }
      },
      targets:  loader,
      opacity:  show ? 1 : 0,
      easing:   'easeInOutQuad',
      duration: 500,
    })
  }

  private initComponent(): void {

    this.viewer.waitInitialize().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((): void=> {      
      this.viewer.getObservable('start_load').pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe((): void => this.toggleLoader(true));
      this.viewer.getObservable('load_success').pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe((): void => this.toggleLoader(false));
      this.viewer.getObservable('load_error').pipe(takeUntilDestroyed(this.destroyRef)).subscribe((): void => this.toggleLoader(false));
    });

  }

}
